import { defaultTheme } from '@antlerengineering/components';
console.log(defaultTheme);
export default defaultTheme;
